import { useLocation } from 'react-router';

export const usePageLocationString = (): string => {
  const location = useLocation();

  return `${location.pathname}${location.search}`;
};
